import agentApiService from "../../../../services/travel/new-policy/agentApiService";
import clientApiService from "../../../../services/travel/new-policy/clientApiService";
import { CheckoutRequest } from "../../../../types/travel/new-policy/api/Checkout";
import { CreateQuoteResponse } from "../../../../types/travel/new-policy/api/Quote";

export const checkoutRequest = (quoteId: string): CheckoutRequest => ({ quote_id: quoteId });

export const checkout = (quote: CreateQuoteResponse, clientId?: string) =>
  clientId ? clientApiService.checkout(clientId, quote.quoteId) : agentApiService.checkout(quote.quoteId);
